<template>
  <base-modal-ex :active.sync="active"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="false"
    :min-width="10"
    has-modal-card>

    <header class="modal-card-head">
      <p class="modal-card-title">Change Password {{ value.username }}</p>
    </header>

    <section class="modal-card-body">
      <div class="columns">
        <div class="column is-full">
          <label class="label">New Password</label>
          <div class="field has-addons">
            <div class="control is-expanded">
              <input class="input"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="new-password"
                v-model="newPassword"
                @blur="validatePassword(newPassword)">
            </div>
            <p class="control">
              <button class="button"
                @click="showPassword=!showPassword">
                <span class="icon has-text-primary">
                  <span class="mso mso-24px">
                    {{ showPassword ? 'visibility' : 'visibility_off' }}
                  </span>
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <label class="label">Confirm Password</label>
          <div class="field has-addons">
            <div class="control is-expanded">
              <input class="input"
                :type="showConfirmPassword ? 'text' : 'password'"
                autocomplete="new-password"
                v-model="confirmNewPassword">
            </div>
            <p class="control">
              <button class="button"
                @click="showConfirmPassword=!showConfirmPassword">
                <span class="icon has-text-primary">
                  <span class="mso mso-24px">
                    {{ showConfirmPassword ? 'visibility' : 'visibility_off' }}
                  </span>
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>

      <span class="help is-danger"
        v-if="!passwordMeetsCriteria">
        {{ passwordMessage }}
      </span>
    </section>

    <footer class="modal-card-foot is-flex is-justify-content-flex-end">
      <div class="buttons">
        <button class="button is-primary tooltip"
          data-tooltip="Save"
          @click="handleSave"
          :disabled="!passwordMeetsCriteria">
          <span class="icon">
            <span class="mso mso-20px mso-fill">
              save
            </span>
          </span>
          <span>Save</span>
        </button>
        <button class="button tooltip"
          @click="handleClose"
          data-tooltip="Cancel">
          <span class="icon">
            <span class="mso mso-20px">
              close
            </span>
          </span>
          <span>Cancel</span>
        </button>
      </div>
    </footer>
  </base-modal-ex>
</template>

<script>
import { BaseModalEx } from '@/components/BulmaModal'
import { UserService } from '../../services'
import HttpStatus from '../../components/http-status'
import { getErrorMessage } from '../auth/ErrorMessage'
export default {
  name: 'ResetPasswordModal',
  components: {
    BaseModalEx
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    active: {
      type: Boolean,
      default: false
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    }
  },
  data() {
    return {
      isActive: this.active || false,
      newPassword: null,
      confirmNewPassword: null,
      passwordMeetsCriteria: false,
      passwordMessage: '',
      showPassword: false,
      showConfirmPassword: false
    }
  },
  watch: {
    newPassword(val) {
      if (!val) {
        this.passwordMeetsCriteria = false
        this.passwordMessage = 'Please enter new password to reset password.'
      }
    },
    confirmNewPassword(val) {
      if (val) {
        if (this.newPassword !== val) {
          this.passwordMeetsCriteria = false
          this.passwordMessage = 'Passwords do not match.'
        } else {
          this.passwordMeetsCriteria = true
          this.passwordMessage = ''
          this.validatePassword(this.newPassword)
        }
      }
    }
  },
  methods: {
    async handleSave() {
      const title = 'User'
      if (!this.passwordMeetsCriteria) {
        this.$notification.openNotificationWithType('danger', title, this.passwordMessage || 'Password does not meet complexity requirements.')
        return
      }
      if (!this.newPassword || !this.confirmNewPassword) {
        this.$notification.openNotificationWithType('danger', title, 'Please enter new password to reset password.')
        return
      }
      if (this.newPassword !== this.confirmNewPassword) {
        this.$notification.openNotificationWithType('danger', title, 'Passwords do not match')
        return
      }
      try {
        const response = await UserService.resetPassword({ UserId: this.value.userId, Password: this.newPassword })
        if (response.status === HttpStatus.NO_CONTENT) {
          this.$notification.openNotificationWithType('success', title, 'Reset password successful')
        }
      } catch (e) {
        var message = getErrorMessage(e.response.data.message).message
        this.$notification.openNotificationWithType('danger', title, message || 'Reset password failed')
      }
      this.newPassword = null
      this.confirmNewPassword = null
      this.$emit('close')
    },
    handleClose() {
      this.newPassword = null
      this.confirmNewPassword = null
      this.$emit('close')
    },
    async validatePassword(password) {
      if (!password || password.length === 0) {
        this.passwordMeetsCriteria = false
        this.passwordMessage = ''
        return
      }
      await UserService.getPasswordComplexity(password).then((result) => {
        this.passwordMeetsCriteria = result.passwordMeetsCriteria
        this.passwordMessage = result.message

        if (result.passwordMeetsCriteria) {
          if (password !== this.confirmNewPassword) {
            this.passwordMeetsCriteria = false
            this.passwordMessage = 'Passwords do not match.'
          }
        }
      })
    }
  }
}
</script>